import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useAddExtractedDenialDataReview() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostMutation(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentExtractedDataDocumentsKeyExtractedDataGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
    },
  })
}
